import React from 'react';
import { NavLink } from 'react-router-dom';

export interface SKUNameCellProps {
  promotion?: any;
  name: string;
  id: string | number;
  editable?: boolean;
}

function SKUNameCell({ promotion, name, id, editable }: SKUNameCellProps) {
  return (
    <div className="grid-sku-name">
      <NavLink to={`/sku/${id}`}>{name}</NavLink>
    </div>
  );
}

export default SKUNameCell;
